import Swiper from 'swiper'

const StepByStep = () => {
  const swiper = new Swiper('.steps-slider', {
    slidesPerView: 'auto',
    loop: true,
  })
}

export default StepByStep
